export const hotelConfig = {
  shehnaiGrand: {
    name: "Shehnai Grand ",
    tagline: "Luxury Stay in the Heart of the City",

    seo: {
  home: {
    title: "Luxury Stay",
    description: "Experience premium hospitality"
  },
  amenities: {
    title: "Amenities",
    description: "Explore our premium facilities"
  },
  contact: {
    title: "Contact Us",
    description: "Reach out for bookings"
  },
  gallery: {
    title: "Gallery",
    description: "View our hotel gallery"
  },
  menu: {
    title: "Menu",
    description: "Explore our dining options"
  },
  wedding: {
    title: "Wedding Packages",
    description: "Premium wedding dining packages"
  },
  about: {
  title: "About Us",
  description:
    "Shehnai Grand is a luxury destination in Kanpur offering premium hospitality, elegant wedding venues."
},
  offers: {
  title: "Special Offers",
  description:
    "Discover our latest offers crafted to give you the best experience at unbeatable value."
},
  privacy: {
    title: "Privacy Policy",
    description: "Read our privacy policy"
  },
  legal: {
    title: "Legal",
    description: "Legal information"
  },
  terms: {
    title: "Terms & Conditions",
    description: "Terms of use"
  }
},
    heroImages: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945",
      "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb",
      "https://images.unsplash.com/photo-1582719508461-905c673771fd"
    ],

    gallery: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945",
      "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb",
      "https://images.unsplash.com/photo-1582719508461-905c673771fd",
      "https://images.unsplash.com/photo-1505691723518-36a5ac3be353",
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4",
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
      "https://images.unsplash.com/photo-1584132967334-10e028bd69f7",
      "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb",
      "https://images.unsplash.com/photo-1582719508461-905c673771fd",
      "https://images.unsplash.com/photo-1505691723518-36a5ac3be353",
    ],

    social: {
      instagram: "https://instagram.com/shehnai_grand",
      facebook: "https://facebook.com/shehnai_grand",
      youtube: "https://youtube.com/@shehnai_grand",
      twitter: "https://x.com/shehnai_grand",
      linkedin: "https://linkedin.com/company/shehnai_grand"
    },

    amenities: [
      {
        name: "Luxury Rooms",
        enabled: true,
        image: "https://images.unsplash.com/photo-1590490360182-c33d57733427",
        description: "Elegant rooms designed for ultimate comfort."
      },
      {
        name: "Swimming Pool",
        enabled: true,
        image: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb",
        description: "Relax in our temperature-controlled pool."
      },
      {
        name: "Fine Dining Restaurant",
        enabled: true,
        image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0",
        description: "Experience gourmet cuisine crafted by our chefs."
      },
      {
        name: "Spa & Wellness",
        enabled: true,
        image: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874",
        description: "Relax and rejuvenate with luxury spa treatments."
      },
      {
        name: "Fitness Center",
        enabled: true,
        image: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f",
        description: "Fully equipped gym for your daily workouts."
      },
      {
        name: "Banquet Hall",
        enabled: true,
        image: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3",
        description: "Elegant banquet halls perfect for weddings and events."
      },
      {
        name: "Wedding Lawn",
        enabled: true,
        image: "https://images.unsplash.com/photo-1520854221256-17451cc331bf",
        description: "Beautiful outdoor lawn for large wedding ceremonies."
      },
      {
        name: "Bridal Suite",
        enabled: true,
        image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
        description: "Luxury suite specially designed for bridal preparation."
      },
      {
        name: "Event Decoration Services",
        enabled: true,
        image: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3",
        description: "Professional decoration services for weddings and events."
      },
      {
        name: "Valet Parking",
        enabled: true,
        image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70",
        description: "Convenient valet parking service for guests."
      },
      {
        name: "Conference & Meeting Rooms",
        enabled: false,
        image: "https://images.unsplash.com/photo-1517502884422-41eaead166d4",
        description: "Modern conference spaces for business meetings."
      }
    ],

    contact: {
      phone: "+91 9999999999",
      email: "info@shehnaiGrand.com",
      address: "Yashoda Nagar, Kanpur, India",
    //  mapLocation: "Shehnai Chauraha, 113 B, Yashoda Nagar, Kanpur, Uttar Pradesh 208011",
      mapLocation: "--",
      location: {
        lat: 26.4104702,
        lng: 80.3299211,
      }

    }
    ,
    menu: [
  {
    category: "Starters",
    items: [
      { name: "Paneer Tikka", price: "₹350", description: "Grilled cottage cheese with spices" },
      { name: "Chicken Wings", price: "₹420", description: "Crispy wings with spicy sauce" }
    ]
  },
  {
    category: "Main Course",
    items: [
      { name: "Butter Chicken", price: "₹550", description: "Rich creamy tomato gravy" },
      { name: "Veg Biryani", price: "₹450", description: "Aromatic basmati rice with spices" }
    ]
  },
  {
    category: "Desserts",
    items: [
      { name: "Gulab Jamun", price: "₹180", description: "Sweet dumplings in syrup" },
      { name: "Ice Cream", price: "₹200", description: "Vanilla / Chocolate / Strawberry" }
    ]
  }
],

offers: [
  {
    title: "Wedding Special",
    description: "Flat 10% off on wedding bookings this season",
    highlight: "10% OFF",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552",
    enabled: true
  },
  {
    title: "Early Bird Offer",
    description: "Book 60 days in advance and get exclusive benefits",
    highlight: "Save More",
    image: "https://images.unsplash.com/photo-1505691938895-1758d7feb511",
    enabled: true
  },
  {
    title: "Weekend Getaway",
    description: "Special pricing for weekend stays with free breakfast",
    highlight: "Weekend Deal",
    image: "https://images.unsplash.com/photo-1501117716987-c8e1ecb2104a",
    enabled: false
  }
],

rooms: [
  {
    name: "Deluxe Room",
    price: "₹4,500 / night",
    image: "https://images.unsplash.com/photo-1566665797739-1674de7a421a",
    description: "Elegant room with modern amenities and city view.",
    features: ["King Bed", "Free WiFi", "Air Conditioning", "TV"],
    enabled: true
  },
  {
    name: "Executive Suite",
    price: "₹7,500 / night",
    image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
    description: "Spacious suite with luxury interiors and lounge area.",
    features: ["Living Area", "Mini Bar", "Premium View"],
    enabled: true
  },
  {
    name: "Presidential Suite",
    price: "₹12,000 / night",
    image: "https://images.unsplash.com/photo-1590490360182-c33d57733427",
    description: "Top-tier luxury experience with premium services.",
    features: ["Private Lounge", "Jacuzzi", "Butler Service"],
    enabled: true
  }
]

},



};